<template>
  <section class="p-4">
    <div class="content" v-if="!loading && !estoreAnalyticsLink">
      <b-row class="justify-content-center my-5">
        <div class="col-10 col-sm-6 col-md-4 col-lg-3 text-center">
          <img
            src="~@/assets/images/capa_1.png"
            alt="Whoops!"
            class="text-center img-fluid"
            style="border: none"
          />
        </div>
      </b-row>
      <b-row class="justify-content-center">
        <b-col lg="6" md="6">
          <div
            id="negative-scenario-container"
            class="text-center"
            v-html="negativeScenarioSpiel"
          ></div>
        </b-col>
      </b-row>
    </div>
    <div
      class="content-body customers-wrapper transaction-history"
      v-else-if="!loading && estoreAnalyticsLink"
    >
      <div class="col-10 col-sm-12 col-md-12 col-lg-12">
        <iframe
          title="Loyalty Analytics Data"
          width="600"
          height="700"
          :src="estoreAnalyticsLink"
          style="border: 0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      negativeScenarioSpiel: `
        <h4 class="text-primary">Good things take time!</h4>
        <p class="text-center w-50 mx-auto">We&#39;re still working on creating a better experience for you. Come back soon to see your customized dashboard.</p>
        `
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("accountProfile", ["detail"]),
    ...mapState("estoreAnalytics", {
      loading: (state) => state.loading,
      estoreAnalyticsLink: (state) => state.estoreAnalyticsLink,
    }),
  },
  async created() {
    this.$store.commit("estoreAnalytics/setLoading", true);

    if (!_.has(this.detail, "plan_details"))
      await this.$store.dispatch("accountProfile/assignMerchantDetail");

    if (this.user.role === "admin" && this.detail.plan_details.enable_estore)
      await this.$store.dispatch("estoreAnalytics/fetchEstoreAnalyticsLink");
    else this.$router.push({ path: "/" });
  }
};
</script>

<style lang="scss">
#negative-scenario-container h4 {
  font-family: MainFontBold, sans-serif;
}
</style>"

<style lang="scss" scoped>
iframe {
  display: block;
  width: 100%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
